import setScrollBarWidth from "set-scrollbar-width"; // Use with the Tailwind Container Break Out extension.
import devMode from "./dev-mode";
import {
	linksCustomization,
	scrollTo,
	responsiveTables,
	smoothScrolling,
	lenis,
} from "./misc";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(SplitText, ScrollTrigger);
//import scrollAnimations from './scrollAnimations-v2';
import magnificPopup from "./popups";
import { basicSlider, bannerSlider } from "./sliders";
import notifications from "../../templates/sections/notifications/notifications";
import { video } from "./video";
import { bannerVideo } from "../../templates/sections/banner/banner-video";
import {
	banner,
	bannerNews,
	bannerAnimation,
	bannerAnimationBlue,
	bannerArrowLanding
} from "../../templates/sections/banner/banner";
import { wpGallery } from "./galleries";
import nav from "./nav";
/* Flexible Content */
import accordion from "../../templates/blocks/accordion";
import tabs from "../../templates/blocks/tabs/tabs";
import textAndMedia from "../../templates/blocks/text-and-media/text-and-media";
import media from "../../templates/blocks/media/media";
import { homepage } from "./home";
import { homepage2 } from "./home_2";
import { homepage3 } from "./home_3";
import { homepage4 } from "./home_4";
import { homepage5 } from "./home_5";
import { homepage6 } from "./home_6";
import { reviews } from "../../templates/blocks/reviews/reviews";
import { blockquote } from "../../templates/blocks/blockquote/blockquote";
import { image_carousel, simple_image_carousel } from "../../templates/blocks/image-carousel/image-carousel";
import { wherenext } from "../../templates/blocks/where-next/where-next";
import { related_news } from "../../templates/blocks/related-news/related-news";
import { upcoming_events } from "../../templates/blocks/upcoming-events/upcoming-events";
import { entrypoint } from "../../templates/blocks/entry-point/entry-point";
import { scrolling_text_teaser } from "../../templates/blocks/scrolling-text-teaser/scrolling-text-teaser";
import { quote_split } from "../../templates/blocks/quote/quote";
// Import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

function consoleMessage() {
	console.log(
		"%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
		"background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
		"background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
		"background: #FFFFFF; padding: 5px 10px;"
	);
}

function usingJS() {
	document.querySelector("html").classList.remove("no-js");
	document.querySelector("html").classList.add("js");
}

// Landing page carousel function
function landingCarousel() {
	const carouselSection = document.querySelector('[data-name="carousel_section_landing"]');
	if (!carouselSection) return;
	
	const carouselSlider = document.querySelector('[data-target="carousel_slider"]');
	if (!carouselSlider) return;
	
	// Add CSS for progress animation if not already in stylesheet
	if (!document.querySelector('#carousel-progress-animation')) {
		const styleSheet = document.createElement('style');
		styleSheet.id = 'carousel-progress-animation';
		styleSheet.textContent = `
			@keyframes progressWidth {
				from { width: 0%; }
				to { width: 100%; }
			}
		`;
		document.head.appendChild(styleSheet);
	}
	
	// Declare shared animation variables
	let autoplayEnabled = false;
	let animationInProgress = false;
	let landingSwiper;
	
	// Set slide duration as a CSS variable for the animation
	document.documentElement.style.setProperty('--slide-duration', '5s');
	
	// Function to animate a slide's content transition
	function animateSlideContent(swiper) {
		const currentSlide = swiper.slides[swiper.activeIndex];
		const illustration = currentSlide.querySelector('.illustration');
		const content = currentSlide.querySelector('[data-name="carousel_item_content"]');
		
		if (!illustration || !content) return;
		
		// Create a fresh timeline for this animation with 1 second delay
		setTimeout(() => {
			const slideTimeline = gsap.timeline();
			
			// Fade out illustration
			slideTimeline.to(illustration, {
				autoAlpha: 0,
				duration: 0.8,
				ease: "power2.out"
			});
			
			// Fade in content slightly before illustration fully fades out
			slideTimeline.to(content, {
				autoAlpha: 1,
				duration: 0.8,
				ease: "power2.out"
			}, "-=0.5");
		}, 1000); // 1 second delay before starting the animation
	}
	
	// Function to reset and start progress bar animation
	function resetProgressAnimation() {
		if (!carouselSlider) return;
		
		// Get all progress elements and reset them
		const progressElements = carouselSlider.querySelectorAll('.swiper-pagination-bullet b');
		progressElements.forEach(element => {
			// Remove animation
			element.style.animation = 'none';
			element.style.width = '0';
			void element.offsetWidth; // Force reflow
		});
		
		// Only start animation on the active bullet if autoplay is enabled
		if (autoplayEnabled) {
			const activeBullet = carouselSlider.querySelector('.swiper-pagination-bullet-active b');
			if (activeBullet) {
				activeBullet.style.animation = `progressWidth var(--slide-duration, 5s) linear forwards`;
			}
		}
	}
	
	// Function to handle transition between slides
	function transitionSlides(swiper, previousIndex, currentIndex) {
		// If animation already in progress, wait
		if (animationInProgress) return;
		
		animationInProgress = true;
		
		// Get previous and current slides
		const previousSlide = swiper.slides[previousIndex];
		const currentSlide = swiper.slides[currentIndex];
		
		// Get elements from both slides
		const prevIllustration = previousSlide?.querySelector('.illustration');
		const prevContent = previousSlide?.querySelector('[data-name="carousel_item_content"]');
		const currIllustration = currentSlide?.querySelector('.illustration');
		const currContent = currentSlide?.querySelector('[data-name="carousel_item_content"]');
		
		// Make current slide visible but with illustration only
		gsap.set(currentSlide, { autoAlpha: 1 });
		gsap.set(currIllustration, { autoAlpha: 1 });
		gsap.set(currContent, { autoAlpha: 0 });
		
		// Fade out previous slide
		const tl = gsap.timeline({
			onComplete: () => {
				// Start the content animation on current slide
				animateSlideContent(swiper);
				animationInProgress = false;
			}
		});
		
		// Fade out previous slide
		tl.to(previousSlide, {
			autoAlpha: 0,
			duration: 0.5,
			ease: "power2.out"
		});
	}
	
	// Initialize the carousel slider with autoplay disabled initially
	landingSwiper = new Swiper(carouselSlider, {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 0, // Set to 0 to handle transitions ourselves
		effect: 'fade',
		loop: true,
		loopedSlides: 1,
		width: null,
		fadeEffect: {
			crossFade: false
		},
		// Initialize with autoplay disabled
		autoplay: false,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: 'bullets',
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
			},
		},
		on: {
			init: function() {
				// Initialize slides but don't start animations yet
				this.slides.forEach(slide => {
					// Initially hide all slides except active one
					const isActive = slide.classList.contains('swiper-slide-active');
					gsap.set(slide, { autoAlpha: isActive ? 1 : 0 });
					
					// Within active slide, show illustration and hide content
					const illustration = slide.querySelector('.illustration');
					const content = slide.querySelector('[data-name="carousel_item_content"]');
					
					if (illustration && content) {
						gsap.set(illustration, { autoAlpha: 1 });
						gsap.set(content, { autoAlpha: 0 });
					}
				});
				
				// Style progress bars
				const bullets = carouselSlider.querySelectorAll('.swiper-pagination-bullet b');
				bullets.forEach(bullet => {
					bullet.style.position = 'absolute';
					bullet.style.left = '0';
					bullet.style.bottom = '0';
					bullet.style.height = '2px';
					bullet.style.width = '0';
					bullet.style.backgroundColor = 'white';
					bullet.style.transition = 'none';
				});
			},
			slideChangeTransitionStart: function() {
				if (!autoplayEnabled) return;
				
				const previousIndex = this.previousIndex;
				const currentIndex = this.activeIndex;
				
				if (previousIndex !== undefined) {
					transitionSlides(this, previousIndex, currentIndex);
				}
			},
			slideChangeTransitionEnd: function() {
				if (!autoplayEnabled) return;
				resetProgressAnimation();
			}
		}
	});

	// Use ScrollTrigger to detect when the carousel is in view and enable autoplay
	ScrollTrigger.create({
		trigger: carouselSection,
		start: "top 80%", // Changed from 50% to 80% - start when section is closer to viewport
		onEnter: () => {
			console.log("Carousel in view - enabling autoplay");
			
			// Enable autoplay only once
			if (autoplayEnabled) return;
			autoplayEnabled = true;
			
			// First, ensure all progress bars are reset to 0 width with no animation
			const allProgressBars = carouselSlider.querySelectorAll('.swiper-pagination-bullet b');
			allProgressBars.forEach(bar => {
				bar.style.animation = 'none';
				bar.style.width = '0';
			});
			
			// Enable autoplay
			landingSwiper.params.autoplay = {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				waitForTransition: false
			};
			
			// Start autoplay
			landingSwiper.autoplay.start();
			
			// Animate the first slide
			animateSlideContent(landingSwiper);
			
			// Start the progress animation on the active bullet
			setTimeout(() => {
				const activeProgressBar = carouselSlider.querySelector('.swiper-pagination-bullet-active b');
				if (activeProgressBar) {
					activeProgressBar.style.animation = `progressWidth var(--slide-duration, 5s) linear forwards`;
				}
			}, 50); // Short delay to ensure DOM updates
		}
	});
}

function imageanim(){
	// Define a variable that will store the Lenis smooth scrolling object
	let lenis;

	// Get the grid element
	const grid = document.querySelector(".grid_scroll_anim");

	// Only continue if grid exists
	if (grid) {
		// Get all grid items within the grid
		const gridItems = grid.querySelectorAll(".grid__item");

		const scroll = () => {
			const viewportHeight = window.innerHeight;
			const endValue = viewportHeight / 2;

			// Loop through each grid item to add animations
			gridItems.forEach((item, index) => {
				// Check for data-origin attribute on the image container
				const imgContainer = item.querySelector('.grid__item-img');
				const originAttribute = imgContainer ? imgContainer.getAttribute('data-origin') : null;
				
				// Set origin based on data attribute or fallback to position detection
				let originX;
				
				if (originAttribute === 'right') {
					originX = 100; // For left images (animation starts from right)
				} else if (originAttribute === 'left') {
					originX = 0;   // For right images (animation starts from left)
				} else {
					// Original fallback logic
					const previousElementSibling = item.previousElementSibling;
					const isLeftSide =
						previousElementSibling &&
						item.offsetLeft + item.offsetWidth <=
							previousElementSibling.offsetLeft + 1;
					originX = isLeftSide ? 100 : 0;
				}

				gsap
					.timeline({
						defaults: {
							ease: "power4",
						},
						scrollTrigger: {
							trigger: item,
							start: "top 80%",
							end: `+=${item.offsetHeight + 200}`,
							scrub: true,
							//markers: true,
						},
					})

					.fromTo(
						item.querySelector(".grid__item-img"),
						{
							scale: 0,
							transformOrigin: `${originX}% 0%`,
						},
						{
							scale: 1,
						}
					)
					.fromTo(
						item.querySelector(".grid__item-img-inner"),
						{
							scale: 3,
							transformOrigin: `${originX}% 0%`,
						},
						{
							scale: 1,
						},
						0
					);
			});
		};

		scroll();
	}
}

function lifeatBoxAnimations() {
	// Get all lifeat_box elements
	const lifeatBoxes = document.querySelectorAll('[data-name^="lifeat_box_"]');
	
	if (!lifeatBoxes.length) return;
	
	lifeatBoxes.forEach(box => {
		const boxName = box.getAttribute('data-name');
		const content = box.children; // All child elements
		
		// Determine clip-path direction based on box name
		let clipPath = {
			initial: '',
			final: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
		};
		
		switch (boxName) {
			case 'lifeat_box_intro':
			case 'lifeat_box_1':
			case 'lifeat_box_3':
				// Clip from top left
				clipPath.initial = 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)';
				break;
			case 'lifeat_box_2':
			case 'lifeat_box_last':
				// Clip from top right
				clipPath.initial = 'polygon(100% 0%, 100% 0%, 100% 0%, 100% 0%)';
				break;
			default:
				// Default to top left for any other lifeat_box elements
				clipPath.initial = 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)';
		}
		
		// Set initial states
		gsap.set(box, {
			clipPath: clipPath.initial
		});
		
		gsap.set(content, {
			opacity: 0
		});
		
		// Handle lifeat_box_intro differently - animate on page load
		if (boxName === 'lifeat_box_intro') {
			const introTl = gsap.timeline({ delay: 1 }); // Small delay after page load
			gsap.set(box, { autoAlpha: 1 });
			// Animate clip-path to reveal the box
			introTl.to(box, {
				clipPath: clipPath.final,
				duration: 1.2,
				ease: "power2.out"
			})
			// Then animate content opacity
			.to(content, {
				opacity: 1,
				duration: 0.6,
				stagger: 0.1,
				ease: "power2.out"
			}, "-=0.3"); // Start slightly before clip animation ends
		} else {
			// Create ScrollTrigger timeline for other boxes
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: box,
					start: "top 80%",
					end: "top 40%",
					scrub: 1,
					//markers: true, // Uncomment for debugging
				}
			});
			
			// Animate clip-path to reveal the box
			tl.to(box, {
				clipPath: clipPath.final,
				duration: 1,
				ease: "power2.out"
			})
			// Then animate content opacity
			.to(content, {
				opacity: 1,
				duration: 0.5,
				stagger: 0.1,
				ease: "power2.out"
			}, "-=0.2"); // Start slightly before clip animation ends
		}
	});
}

/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function () {
	// Init
	consoleMessage();
	nav();
	usingJS();
	setScrollBarWidth();
	// devMode()
	linksCustomization();
	scrollTo();
	responsiveTables();
	video();
	wpGallery();
	smoothScrolling();
	//scrollAnimations()
	notifications();
	banner();
	bannerNews();
	bannerAnimation();
	bannerAnimationBlue();
	bannerArrowLanding();
	bannerVideo();

	// Homepage
	
	// Popups 
	magnificPopup();

	// Sliders
	basicSlider();
	bannerSlider()
    
    // Landing Page
    landingCarousel();

	// Flexible Content
	accordion();
	tabs();
	textAndMedia();
	//media()
	reviews();
	blockquote(); 
	image_carousel();
	simple_image_carousel();
	wherenext();
	related_news();
	upcoming_events();
	entrypoint(); 
	imageanim();
	scrolling_text_teaser();
	quote_split();

	homepage();
	homepage2();
	homepage3();
	homepage4();
	homepage5();
	homepage6();

	lifeatBoxAnimations();
};

// Activity page - Skip to list button functionality
function activitySkipToList() {
    // Get the skip to list button
    const skipToListBtn = document.querySelector('.button[data-scroll-to]');
    if (!skipToListBtn) return;

    skipToListBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the target element
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement && lenis) {
            // If using Lenis for smooth scrolling
            lenis.scrollTo(targetElement, {
                offset: -50, // Adjust this offset as needed
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
            });
        } else if (targetElement) {
            // Fallback to standard scrolling
            window.scrollTo({
                top: targetElement.offsetTop - 50,
                behavior: 'smooth'
            });
        }
    });
}

// Call the function immediately after DOM is ready
document.addEventListener('DOMContentLoaded', activitySkipToList);

jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
			magnificPopupIframe();
			magnificPopupInline();
			magnificPopupSingleImage();
			magnificPopupGalleryImage();
		});
	}

	
	lifeat: {
		if ($('[data-name="life_text"]').length) {
			
			const lifetext = document.querySelector('[data-name="life_text"]');

			// Split text for character-by-character animation
			const lifetextSplit = new SplitText(lifetext, {
				type: "chars, words",
				linesClass: "char",
			});

			// Create timeline for life text animation
			let lifeTextTL = gsap.timeline({
				scrollTrigger: {
					trigger: lifetext,
					start: "top 80%",
					end: "top 50%",
					scrub: true,					
				}
			});

			// Clear any existing animations
			lifeTextTL.clear();
			
			// Add animation for each character with staggered timing
			lifeTextTL.from(lifetextSplit.chars, { 
				opacity: 0.2, 
				stagger: 0.02,
				ease: "power1.out",
				duration: 0.35
			}, 0);
		}
	}
	forminline: {
		if ($('[data-general-enquiry]').length) {
			const generalEnquiryValue = $('[data-general-enquiry]').attr('data-general-enquiry');
			
			if (generalEnquiryValue && generalEnquiryValue !== '') {
				// Find the select form element with id input_1_7
				const selectElement = document.getElementById('input_1_7');
				
				if (selectElement) {
					// Find the option that matches the generalEnquiryValue
					const options = selectElement.options;
					
					for (let i = 0; i < options.length; i++) {
						if (options[i].text === generalEnquiryValue) {
							// Select this option
							selectElement.selectedIndex = i;
							
							// Trigger change event to ensure any dependent form logic is updated
							const changeEvent = new Event('change', { bubbles: true });
							selectElement.dispatchEvent(changeEvent);
							
							break;
						}
					}
				}
			}
		}
	}
	findus_line: {
		if ($('[data-name="findus_line"]').length) {
			const findusLine = document.querySelector('[data-name="findus_line"]');
			
			// Only run animation on screens 1024px and larger
			if (window.innerWidth >= 1024) {
				// Initial state - invisible and scaled to 0 width
				gsap.set(findusLine, {
					scaleX: 0,
					transformOrigin: "left center"
				});
				
				// Create the ScrollTrigger animation
				gsap.to(findusLine, {
					scaleX: 1,
					ease: "power2.out",
					scrollTrigger: {
						trigger: findusLine,
						start: "top 70%", // Start when element is 70% from top of viewport
						end: "top 40%",   // End when element is 60% from top of viewport
						scrub: 1,         // Smooth scrubbing effect
						//markers: true,   // Uncomment for debugging
					}
				});
			}
		}
	}
	ecommerce: {
		if ($('[data-block="ecommerce"]').length) {
			const modal = document.getElementById('productModal');
			const modalImg = modal.querySelector('img');
			
			// Initialize GSAP timeline for modal
			const modalTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Setup the animation
			modalTimeline
				.fromTo(modal, 
					{ display: 'none', opacity: 0 },
					{ display: 'flex', opacity: 1 }
				)
				.fromTo('.modal-content',
					{ scale: 0.8, opacity: 0 },
					{ scale: 1, opacity: 1 },
					'-=0.2'
				);

			// Handle product click
			$('.product-link').on('click', function(e) {
				e.preventDefault();
				const productImg = $(this).find('img').attr('src');
				modalImg.src = productImg;
				modalTimeline.play();
			});

			// Handle close button click
			$('#closeModal').on('click', function() {
				modalTimeline.reverse();
			});

			// Close on background click
			$(modal).on('click', function(e) {
				if (e.target === modal) {
					modalTimeline.reverse();
				}
			});

			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && modal.style.display !== 'none') {
					modalTimeline.reverse();
				}
			});
		}
	}

	boxcontent_life: {
		if ($('#boxcontent_life').length) {
			// Initialize GSAP timeline for Life at Tonbridge popup
			const lifePopupTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Setup the animation
			lifePopupTimeline
				.fromTo('#boxcontent_life', 
					{ autoAlpha: 0 },
					{ autoAlpha: 1, display: 'flex' }
				)
				.fromTo('#boxcontent_life > div', 
					{ autoAlpha: 0, y: 20 },
					{ autoAlpha: 1, y: 0 },
					'-=0.1'
				);

			// Handle open popup click
			$('[data-name="open_popup_life"]').on("click", function (e) {
				e.preventDefault();
				
				// Show popup
				lifePopupTimeline.play();
				
				// Disable scroll while popup is open
				if (lenis) {
					lenis.stop();
				}
			});
			
			// Function to close the modal
			const closeLifePopup = function() {
				lifePopupTimeline.reverse();
				
				// Re-enable scrolling
				if (lenis) {
					setTimeout(() => {
						lenis.start();
					}, 300); // Wait for animation to complete
				}
			};
			
			// Close on X button click
			$(document).on(
				"click",
				'[data-element="close_popup_life"]',
				function (event) {
					event.preventDefault();
					closeLifePopup();
				}
			);
			
			// Close on background click
			$("#boxcontent_life").on("click", function(event) {
				// Only close if the click is directly on the background, not on its children
				if (event.target === this) {
					closeLifePopup();
				}
			});
			
			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#boxcontent_life').css('opacity') > 0) {
					closeLifePopup();
				}
			});
		}	
	}
	boxcontent_booking: {
		if ($('#boxcontent_booking').length) {
			// Initialize GSAP timeline for booking at Tonbridge popup
			const bookingPopupTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Setup the animation
			bookingPopupTimeline
				.fromTo('#boxcontent_booking', 
					{ autoAlpha: 0 },
					{ autoAlpha: 1, display: 'flex' }
				)
				.fromTo('#boxcontent_booking > div', 
					{ autoAlpha: 0, y: 20 },
					{ autoAlpha: 1, y: 0 },
					'-=0.1'
				);

			// Handle open popup click
			$('[data-name="open_popup_booking"]').on("click", function (e) {
				e.preventDefault();
				
				// Show popup
				bookingPopupTimeline.play();
				
				// Disable scroll while popup is open
				if (lenis) {
					lenis.stop();
				}
			});
			
			// Function to close the modal
			const closebookingPopup = function() {
				bookingPopupTimeline.reverse();
				
				// Re-enable scrolling
				if (lenis) {
					setTimeout(() => {
						lenis.start();
					}, 300); // Wait for animation to complete
				}
			};
			
			// Close on X button click
			$(document).on(
				"click",
				'[data-element="close_popup_booking"]',
				function (event) {
					event.preventDefault();
					closebookingPopup();
				}
			);
			
			// Close on background click
			$("#boxcontent_booking").on("click", function(event) {
				// Only close if the click is directly on the background, not on its children
				if (event.target === this) {
					closebookingPopup();
				}
			});
			
			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#boxcontent_booking').css('opacity') > 0) {
					closebookingPopup();
				}
			});
		}	
	}
	nolink: {
		if ($('.nolink').length) {
			$('.nolink').on("click", function (e) {
				e.preventDefault();
				
			});
		}
	}

	disablecalendarlinks: {
		$(document).on('click', 'a.tribe-events-pro-week-grid__event-link.tooltipstered', function(e) {
			e.preventDefault();
		});
	}
	boxcontent_activitybooking: {
		if ($('#boxcontent_activitybooking').length) {
			// Initialize GSAP timeline for booking at Tonbridge popup
			const bookingPopupTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Setup the animation
			bookingPopupTimeline
				.fromTo('#boxcontent_activitybooking', 
					{ autoAlpha: 0 },
					{ autoAlpha: 1, display: 'flex' }
				)
				.fromTo('#boxcontent_activitybooking > div', 
					{ autoAlpha: 0, y: 20 },
					{ autoAlpha: 1, y: 0 },
					
				);

			// Handle open popup click
			$('[data-name="open_popup_activitybooking"]').on("click", function (e) {
				e.preventDefault();
				const termId = $(this).data('termid');
				

				// Show popup
				bookingPopupTimeline.play();
				
				// Load content via AJAX
				$.ajax({
					type: "GET",
					url: my_ajax_object.ajax_url,
					dataType: "html",
					data: {
						action: "my_load_ajax_content_activity",
						term_id: termId,
					},
				}).done(function (data) {
					$("#boxcontent_activitybooking").html(data);
					

					// Reinitialize accordion functionality
					const accordionTriggers = document.querySelectorAll('#boxcontent_activitybooking [data-target="accordion-trigger"]');
					accordionTriggers.forEach(trigger => {
						trigger.addEventListener('click', function() {
							const accordion = this.closest('[data-target="accordion"]');
							const content = accordion.querySelector('[data-target="accordion-content"]');
							const state = accordion.getAttribute('data-state');
							
							if (state === 'closed') {
								// Open accordion
								accordion.setAttribute('data-state', 'open');
								content.style.height = content.scrollHeight + 'px';
								trigger.querySelector('.icon').classList.add('active');
							} else {
								// Close accordion
								accordion.setAttribute('data-state', 'closed');
								content.style.height = '0';
								trigger.querySelector('.icon').classList.remove('active');
							}
						});
					});
				});
				
				// Disable scroll while popup is open
				if (lenis) {
					lenis.stop();
				}
			});
			
			// Function to close the modal
			const closebookingPopup = function() {
				bookingPopupTimeline.reverse();
				gsap.to("#boxcontent_activitybooking > div", {
					autoAlpha: 0,
					duration: 0.5,
				});
				// Re-enable scrolling
				if (lenis) {
					setTimeout(() => {
						lenis.start();
					}, 300); // Wait for animation to complete
				}
			};
			
			// Close on X button click
			$(document).on(
				"click",
				'[data-element="close_popup_activitybooking"]',
				function (event) {
					event.preventDefault();
					closebookingPopup();
				}
			);
			
			// Close on background click
			$("#boxcontent_activitybooking").on("click", function(event) {
				// Only close if the click is directly on the background, not on its children
				if (event.target === this) {
					closebookingPopup();
				}
			});
			
			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#boxcontent_activitybooking').css('opacity') > 0) {
					closebookingPopup();
				}
			});
		}	
	}

	grid_popup: {
		if ($('.grid_popup').length) {
			// Initialize GSAP timeline for text modal
			const gridModalTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Setup the animation
			gridModalTimeline
				.fromTo('#boxcontent_grid', 
					{ autoAlpha: 0 },
					{ autoAlpha: 1 }
				)
				.fromTo('#boxcontent_grid > div', 
					{ autoAlpha: 0, y: 20 },
					{ autoAlpha: 1, y: 0 },
					'-=0.1'
				);

			// Handle grid popup click
			$('.grid_popup').on("click", function (e) {
				e.preventDefault();
				
				// Get data from clicked element
				const popupContent = $(this).attr("data-popup-content");
				const popupTitle = $(this).attr("data-popup-title");
				const popupImage = $(this).attr("data-popup-image");
				
				// Set content in popup
				$('[data-name="grid_popup_title"]').html(popupTitle);
				$('[data-name="grid_popup_content"]').html(popupContent);
				
				// Handle image if it exists
				if (popupImage) {
					const imageElement = $('[data-name="grid_popup_image"]');
					imageElement.attr('src', popupImage);
					imageElement.removeClass('hidden');
				} else {
					$('[data-name="grid_popup_image"]').addClass('hidden');
				}
				
				// Show popup
				gridModalTimeline.play();
				
				// Disable scroll while popup is open
				if (lenis) {
					lenis.stop();
				}
			});
			
			// Function to close the modal
			const closeGridModal = function() {
				gridModalTimeline.reverse();
				
				// Re-enable scrolling
				if (lenis) {
					setTimeout(() => {
						lenis.start();
					}, 300); // Wait for animation to complete
				}
			};
			
			// Close on X button click
			$(document).on(
				"click",
				'[data-element="close_popup_grid"]',
				function (event) {
					event.preventDefault();
					closeGridModal();
				}
			);
			
			// Close on background click
			$("#boxcontent_grid").on("click", function(event) {
				if (event.target === this) {
					closeGridModal();
				}
			});
			
			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#boxcontent_grid').css('opacity') > 0) {
					closeGridModal();
				}
			});
		}	
	}

	grid_popup_gallery: {
		if ($('.grid_popup_gallery').length) {
			// Initialize GSAP timeline for gallery modal
			const gridGalleryModalTimeline = gsap.timeline({
				paused: true,
				defaults: { duration: 0.3, ease: 'power2.out' }
			});

			// Initialize Swiper
			let gallerySwiper = null;

			// Setup the gallery popup animation
			gridGalleryModalTimeline
				.fromTo('#boxcontent_grid_gallery', 
					{ autoAlpha: 0 },
					{ autoAlpha: 1 }
				)
				.fromTo('#boxcontent_grid_gallery > div', 
					{ autoAlpha: 0, y: 20 },
					{ autoAlpha: 1, y: 0 },
					'-=0.1'
				);

			// Handle grid popup gallery click
			$('.grid_popup_gallery').on("click", function (e) {
				e.preventDefault();
				
				// Get gallery images from data attribute
				const galleryImages = JSON.parse($(this).attr("data-popup-gallery") || "[]");

				// Initialize or update Swiper
				if (gallerySwiper) {
					gallerySwiper.destroy();
				}

				// Clear existing slides
				$('.gallerySwiper .swiper-wrapper').empty();

				// Add new slides
				galleryImages.forEach(imgSrc => {
					$('.gallerySwiper .swiper-wrapper').append(`
						<div class="swiper-slide">
							<img src="${imgSrc}" alt="" class="w-full h-auto object-cover">
						</div>
					`);
				});

				// Initialize Swiper
				gallerySwiper = new Swiper('.gallerySwiper', {
					modules: [Navigation, Pagination],
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
				
				// Show gallery popup
				gridGalleryModalTimeline.play();
				
				// Disable scroll while popup is open
				if (lenis) {
					lenis.stop();
				}
			});

			// Function to close the gallery modal
			const closeGridGalleryModal = function() {
				gridGalleryModalTimeline.reverse();
				
				// Destroy Swiper when closing
				if (gallerySwiper) {
					gallerySwiper.destroy();
					gallerySwiper = null;
				}
				
				// Re-enable scrolling
				if (lenis) {
					setTimeout(() => {
						lenis.start();
					}, 300); // Wait for animation to complete
				}
			};

			// Close on X button click for gallery popup
			$(document).on(
				"click",
				'[data-element="close_popup_grid_gallery"]',
				function (event) {
					event.preventDefault();
					closeGridGalleryModal();
				}
			);

			// Close on background click for gallery popup
			$("#boxcontent_grid_gallery").on("click", function(event) {
				if (event.target === this) {
					closeGridGalleryModal();
				}
			});
			
			// Close on ESC key
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#boxcontent_grid_gallery').css('opacity') > 0) {
					closeGridGalleryModal();
				}
			});
		}	
	}
	tribe_events: {
		if (document.querySelector('.tribe-common')) {
		if ($('[data-js="tribe-events-accordion-trigger tribe-filter-bar-c-filter-toggle"]').length) {
			$('[data-js="tribe-events-accordion-trigger tribe-filter-bar-c-filter-toggle"]').trigger('click');
		}

		// Sort filter dropdown options
		if (document.querySelector('.tribe-filter-bar')) {
			setTimeout(function() {
				const dropdownList = document.querySelector('.select2-results__options');
				if (dropdownList) {
					const options = Array.from(dropdownList.querySelectorAll('li'));
					options.sort((a, b) => {
						const textA = a.textContent.trim();
						const textB = b.textContent.trim();
						return textA.localeCompare(textB);
					});
					
					options.forEach(option => {
						dropdownList.appendChild(option);
					});
				}
			}, 1000);
		}

		// Disable Lenis smoothing inside all Events Calendar containers
		const applyLenisPreventToTribe = function() {
			const nodes = document.querySelectorAll('div.tribe-common:not([data-lenis-prevent])');
			nodes.forEach(node => {
				node.setAttribute('data-lenis-prevent', '');
			});
		};
		// Apply immediately
		applyLenisPreventToTribe();
		// Observe DOM for dynamically injected Events Calendar nodes
		const tribeObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(node) {
					if (!(node instanceof HTMLElement)) return;
					if (node.matches && node.matches('div.tribe-common')) {
						node.setAttribute('data-lenis-prevent', '');
					}
					if (node.querySelectorAll) {
						node.querySelectorAll('div.tribe-common').forEach(function(el) {
							el.setAttribute('data-lenis-prevent', '');
						});
					}
				});
			});
		});
		tribeObserver.observe(document.body, { childList: true, subtree: true });
		console.log('tribe_events');
		}
	}
	team: {
		if ($('[data-target="team_page"]').length) {
			$('[data-target="team_box"]').on("click", function (e) {
				e.preventDefault();
				var postid = $(this).attr("data-postid");
				var pagetitle = $(this).attr("data-pagetitle");
				gsap.to("#boxcontent_team", { autoAlpha: 1, duration: 0.3 });
				$.ajax({
					type: "GET",
					url: my_ajax_object.ajax_url,
					dataType: "html",
					data: {
						action: "my_load_ajax_content_team",
						idpost: postid,
						pagetitle: pagetitle,
					},
				}).done(function (data) {
					$("#boxcontent_team").html(data);
					gsap.from("#boxcontent_team > div", {
						autoAlpha: 0,
						duration: 0.6,
					});
					
					// Function to close the modal
					const closeTeamModal = function() {
						let tl = gsap.timeline();
						tl.to("#boxcontent_team > div", {
							autoAlpha: 0,
							duration: 0.5,
						}).to("#boxcontent_team", {
							autoAlpha: 0,
							duration: 0.5,
						}, "-=0.5");
					};
					
					// Close on X button click
					$(document).on(
						"click",
						'[data-element="close_popup_team"]',
						function (event) {
							closeTeamModal();
						}
					);
					
					// Close on background click
					$("#boxcontent_team").on("click", function(event) {
						// Only close if the click is directly on the background, not on its children
						if (event.target === this) {
							closeTeamModal();
						}
					});
				});
			});
		}
	}
});